
export default function SectorDetailsPage() {
  return (
    <div>SectorDetailsPage</div>
  )
}
